import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "@fortawesome/fontawesome-free/css/all.min.css";
import defaultAvatar from "../images/download.jpg";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

function CollectionAgent() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [items, setItems] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [imageUrl, setImageUrl] = useState(null);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [showCamera, setShowCamera] = useState(false);
  const [stream, setStream] = useState(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [touched, setTouched] = useState({
    aadharNo: false,
    agentid: false,
    name: false,
    password: false,
    contactno: false,
    statuss: false,
    address: false,
  });
  const [formData, setFormData] = useState({
    image: "",
    aadharNo: "",
    agentid: "",
    name: "",
    password: "",
    contactno: "",
    statuss: "",
    address: "",
    id: "",
  });

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (!isModalOpen && !isEditMode) {
      setTouched({
        aadharNo: false,
        agentid: false,
        name: false,
        password: false,
        contactno: false,
        statuss: false,
        address: false,
      });
      setFormData({
        image: "",
        aadharNo: "",
        agentid: "",
        name: "",
        password: "",
        contactno: "",
        statuss: "",
        address: "",
        id: "",
      });
      setSelectedImage(null);
      setImageUrl(null); 
      setIsEditMode(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  useEffect(() => {
    if (formData.image) {
      // Logic to handle image URL if needed
      console.log("Image changed:", formData.image);
    }
  }, [formData.image, selectedImage]);

  const fetchItems = async () => {
    setIsLoading(true);
    try {
      const accessToken = sessionStorage.getItem("access_token");

      // Fetch data from the backend, including image names
      const response = await axios.get(`${baseURL}/getAllAdmin`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const itemsWithImages = await Promise.all(
        response.data.map(async (item) => {
          if (item.image) {
            try {
              const imageResponse = await axios.get(
                `${baseURL}/images/AgentImages/${item.image}`,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`,
                  },
                  responseType: "blob",
                }
              );
              const imageURL = URL.createObjectURL(imageResponse.data);
              return { ...item, imageURL };
            } catch (imageError) {
              console.error("Error fetching image:", imageError);
              return { ...item, imageURL: null };
            }
          } else {
            return { ...item, imageURL: null };
          }
        })
      );

      setItems(itemsWithImages);
    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const openCamera = async () => {
    setShowCamera(true);

   
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }

    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
        audio: false,
      });

      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;

        videoRef.current.onloadedmetadata = () => {
          videoRef.current
            .play()
            .then(() => {
              console.log("Video is playing");
            })
            .catch((err) => {
              console.error("Error playing video:", err);
            });
        };
      }

      setStream(mediaStream);
    } catch (error) {
      console.error("Error accessing camera:", error);
      alert("Could not access the camera.");
    }
  };

  const closeCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }

    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }

    setShowCamera(false);
  };
  const captureImage = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
  
    if (canvas && video) {
      const context = canvas.getContext("2d");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
  
      canvas.toBlob((blob) => {
        if (blob) {
          const timestamp = Date.now();
          const fileName = `collectionagent_${timestamp}.jpg`;
          const imageFile = new File([blob], fileName, { type: "image/jpeg" });
  
          const imageUrl = URL.createObjectURL(imageFile);
  
          setSelectedImage(imageFile);
  
          setFormData((prev) => ({
            ...prev,
            image: fileName,       
            imageURL: imageUrl,  
          }));
  
          closeCamera();
        }
      }, "image/jpeg");
    }
  
    setShowCamera(false);
  };
  
  
  const updateData = async (id) => {
    const item = items.find((item) => item.id === id);
  
    const isValidImage =
      item.image &&
      typeof item.image === "string" &&
      item.image !== "blob" &&
      item.image !== "[object Object]" &&
      item.image !== "null";
  
    if (isValidImage) {
   
      let imageURL = `${baseURL}/images/AgentImages/${item.image}`;

      if (item.image) {
        try {
          const accessToken = sessionStorage.getItem("access_token");
          const response = await axios.get(
            `${baseURL}/images/AgentImages/${item.image}`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
              responseType: "blob",
            }
          );
          imageURL = URL.createObjectURL(response.data);
        } catch (error) {
          console.error("Error fetching image:", error);
          imageURL = null;
        }
      }

      setFormData({
        image: item.image,
        imageURL: imageURL,
        id: item.id,
        aadharNo: item.aadhar_no,
        agentid: item.admin_id,
        name: item.name,
        password: item.password,
        contactno: item.contact_no,
        statuss: item.statuss,
        address: item.address,
      });

      console.log("Form Data:", formData);
      setSelectedImage(null);
      setIsEditMode(true);
      setIsModalOpen(true);
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
      setFormData({
        ...formData,
        image: file.name,
      });
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto"; // Reset overflow on unmount or modal close
    };
  }, [isModalOpen]);

  useEffect(() => {
    if (isEditMode) {
      setSelectedImage(null);
    }
  }, [isEditMode]);

  const handleEdit = async () => {
    console.log("Form Data before update:", formData);

    setIsSubmitted(true);
    const newErrors = {};
    for (const field in formData) {
      newErrors[field] = validateField(field, formData[field]);
    }

    if (Object.values(newErrors).some((error) => error)) {
      setErrors(newErrors);
      return;
    }

    let isAadharDuplicate = false;
    if (formData.aadharNo) {
      isAadharDuplicate = items.some(
        (item) =>
          item.aadhar_no === formData.aadharNo && item.id !== formData.id
      );
    }
    if (isAadharDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Aadhaar number already exists!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    let isContactNoDuplicate = false;
    if (formData.contactno) {
      isContactNoDuplicate = items.some(
        (item) =>
          item.contact_no === formData.contactno && item.id !== formData.id
      );
    }
    if (isContactNoDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Contact number already exists!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    let isAgentIdDuplicate = false;
    if (formData.agentid) {
      isAgentIdDuplicate = items.some(
        (item) => item.admin_id === formData.agentid && item.id !== formData.id
      );
    }
    if (isAgentIdDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Agent ID already exists!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    const data = new FormData();
    if (selectedImage) {
      data.append("image", selectedImage);
      console.log(selectedImage);
      console.log("Image appended:", selectedImage);
    }

    data.append("id", formData.id);

    data.append("aadharNo", formData.aadharNo);
    data.append("agentid", formData.agentid);
    data.append("name", formData.name);
    data.append("password", formData.password);
    data.append("contactno", formData.contactno);
    data.append("statuss", formData.statuss);
    data.append("address", formData.address);

    console.log("FormData being sent:", Array.from(data.entries()));

    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.put(`${baseURL}/updateAdmin`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`, // Add the access token here
        },
      });

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          text: "Agent updated successfully!",
          timer: 2000,
          showConfirmButton: false,
        });

        fetchItems();
        toggleModal();
        setIsEditMode(false);
      } else {
        console.error("Error updating agent:", response.data);
      }
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let formattedValue = value;

    if (name === "aadharNo") {
      formattedValue = formattedValue.replace(/(\d{4})(?=\d)/g, "$1-"); // Add hyphen after every 4 digits
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: formattedValue,
    }));

    setTouched((prevTouched) => ({
      ...prevTouched,
      [name]: true,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validateField(name, formattedValue),
    }));
  };
  const validateField = (name, value) => {
    let error = "";

    // Required fields
    if (
      (name === "name" ||
        name === "contactno" ||
        name === "agentid" ||
        name === "password") &&
      !value.trim()
    ) {
      return "Required";
    }

    // Validation for contact number
    if (name === "contactno" && value) {
      if (!/^\d{10}$/.test(value)) {
        error = "Contact number must be 10 digits";
      } else if (!/^[9|8|7|6]/.test(value)) {
        error = "Contact number must start with 9, 8, 7, or 6";
      }
    }

    // Validation for aadharNo only if value is present
    if (name === "aadharNo" && value) {
      if (!/^\d{4}-\d{4}-\d{4}$/.test(value)) {
        error = "Aadhar number must be in the format xxxx-xxxx-xxxx";
      }
    }

    // Validation for agentid only if value is present
    if (name === "agentid" && value) {
      if (!/^[a-zA-Z0-9]+$/.test(value)) {
        error = "Account number must contain only letters and numbers";
      }
    }

    // Password length check (only if value is present)
    if (name === "password" && value && value.length < 8) {
      error = "Password must be at least 8 characters long";
    }

    return error;
  };

  const handleDelete = (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteItem(item.id);
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The user has been deleted.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    });
  };

  const deleteItem = async (id) => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.delete(`${baseURL}/deleteAdmin`, {
        data: { id },
        headers: {
          Authorization: `Bearer ${accessToken}`, // Add the access token here
        },
      });
      if (response.status === 200) {
        fetchItems();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Deletion Failed",

        timer: 3000,
        showConfirmButton: false,
      });
    }
  };

  //Adding new agent

  const handleSubmit = async () => {
    setTouched({
      aadharNo: false,
      agentid: true,
      name: true,
      password: true,
      contactno: true,
      statuss: true,
      address: true,
      aadharNo: true,
    });
    setIsSubmitted(true);

    const newErrors = {};
    for (const field in formData) {
      newErrors[field] = validateField(field, formData[field]);
    }

    if (Object.values(newErrors).some((error) => error)) {
      setErrors(newErrors);
      return;
    }
    let isAadharDuplicate = false;
    if (formData.aadharNo) {
      isAadharDuplicate = items.some(
        (item) => item.aadhar_no === formData.aadharNo
      );
    }
    if (isAadharDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Aadhaar number already exists!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    let isContactNoDuplicate = false;
    if (formData.contactno) {
      isContactNoDuplicate = items.some(
        (item) => item.contact_no === formData.contactno
      );
    }
    if (isContactNoDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Contact number already exists!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    let isAgentIdDuplicate = false;
    if (formData.agentid) {
      isAgentIdDuplicate = items.some(
        (item) => item.admin_id === formData.agentid
      );
    }
    if (isAgentIdDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Agent ID already exists!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    const data = new FormData();
    const defaultAvatarPath =
      "https://i.pinimg.com/474x/51/f6/fb/51f6fb256629fc755b8870c801092942.jpg";
    const imageToUpload = selectedImage || defaultAvatarPath;

    if (selectedImage) {
      data.append("image", selectedImage);
      console.log("Selected Image:", selectedImage);
    } else {
      const response = await fetch(defaultAvatar);

      const blob = await response.blob();
      const defaultFile = new File([blob], "default-avatar.jpg", {
        type: blob.type,
      });
      data.append("image", defaultFile);
      console.log("Default Avatar Image:", defaultFile);
    }

    data.append("aadharNo", formData.aadharNo);
    data.append("agentid", formData.agentid);
    data.append("name", formData.name);
    data.append("password", formData.password);
    data.append("contactno", formData.contactno);
    data.append("statuss", formData.statuss);
    data.append("address", formData.address);

    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.post(`${baseURL}/insertAdmin`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`, // Add the access token here
        },
      });

      Swal.fire({
        icon: "success",
        text: "Agent added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });

      toggleModal();
      fetchItems();
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };
  const filteredItems = items.filter(
    (item) =>
      item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.admin_id.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.contact_no.includes(searchQuery) ||
      item.aadhar_no.includes(searchQuery)
  );

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="bg-gray-100 flex flex-col w-full">
      <main className="flex-grow p-6 w-full">
        <h2 className="text-3xl font-bold text-center mt-5">
          Collection Agent
        </h2>

        {/* Table */}
        <div className="mt-6 bg-white shadow rounded-lg p-4 ml-0 sm:ml-0 md:ml-28 lg:ml-64">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0 mb-4">
            <div className="flex items-center space-x-2">
              <label className="md:text-sm">Show</label>
              <select
                className="border border-gray-300 rounded p-1"
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                value={itemsPerPage}
              >
                <option className="md:text-xs" value="10">
                  10
                </option>
                <option className="md:text-xs" value="25">
                  25
                </option>
                <option className="md:text-xs" value="50">
                  50
                </option>
              </select>
              <span>entries</span>
            </div>

            <div className="flex items-center space-x-4 overflow-y-auto">
              <button
                onClick={() => {
                  setIsEditMode(false);
                  toggleModal();
                }}
                className="bg-green-500 text-white px-4 py-2 rounded w-full sm:w-auto"
              >
                Add Agent
              </button>

              {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="relative w-full sm:w-full md:w-1/2 max-h-[70vh] overflow-y-auto bg-white rounded-lg p-4 top-12 sm:top-16 md:top-24">
                    <div className="flex justify-between items-center mb-4">
                      <h2 className="text-lg md:text-xl font-semibold">
                        {isEditMode ? "Update Agent" : "Add Agent"}
                      </h2>
                      <button
                        onClick={() => {
                          setIsEditMode(false);
                          toggleModal();
                        }}
                        className="text-gray-600 text-2xl"
                      >
                        &times;
                      </button>
                    </div>
                    <form className="space-y-4">
                      <div className="flex flex-col items-center mb-6">
                        <label className="relative cursor-pointer">
                          <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gray-200 overflow-hidden flex items-center justify-center">
                            <img
                              src={
                                selectedImage
                                  ? URL.createObjectURL(selectedImage)
                                  : formData.imageURL
                                  ? formData.imageURL
                                  : defaultAvatar
                              }
                              alt="Profile Preview"
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            className="hidden"
                          />
                        </label>
                        <span className="text-sm text-gray-600 mt-2">
                          Photo
                        </span>
                        <div className="mt-2 flex flex-col items-center">
                          <button
                            type="button"
                            onClick={openCamera}
                            className="text-blue-500 underline text-sm"
                          >
                            Use Camera
                          </button>
                        </div>

                        {showCamera && (
                          <div className="my-4">
                            <video
                              ref={videoRef}
                              autoPlay
                              playsInline
                              className="w-full rounded shadow"
                            />
                            <canvas ref={canvasRef} className="hidden" />
                            <div className="flex justify-end space-x-2 mt-2">
                              <button
                                onClick={closeCamera}
                                type="button"
                                className="bg-red-500 text-white px-3 py-1 rounded"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={captureImage}
                                type="button"
                                className="bg-green-500 text-white px-3 py-1 rounded"
                              >
                                Capture
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-gray-600">
                            Aadhar No
                          </label>
                          <input
                            type="text"
                            name="aadharNo"
                            value={formData.aadharNo || ""}
                            placeholder="Enter aadhar no. in xxxx-xxxx-xxxx format"
                            onChange={handleInputChange}
                            className={`border p-2 w-full placeholder:text-sm  ${
                              errors.aadharNo && touched.aadharNo
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.aadharNo && touched.aadharNo && (
                            <span className="text-red-500 text-sm">
                              {errors.aadharNo}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Agent ID<span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            name="agentid"
                            value={formData.agentid || ""}
                            placeholder="Enter agent id "
                            onChange={handleInputChange}
                            className={`border p-2 w-full placeholder:text-sm ${
                              errors.agentid && touched.agentid
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.agentid && touched.agentid && (
                            <span className="text-red-500 text-sm">
                              {errors.agentid}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Name <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            name="name"
                            value={formData.name || ""}
                            onChange={handleInputChange}
                            className={`border p-2 w-full  ${
                              errors.name && touched.name
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.name && touched.name && (
                            <span className="text-red-500 text-sm">
                              {errors.name}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Password <span className="text-red-500">*</span>{" "}
                          </label>
                          <input
                            type="text"
                            name="password"
                            value={formData.password || ""}
                            placeholder="Enter a valid password"
                            onChange={handleInputChange}
                            className={`border p-2 w-full placeholder:text-sm ${
                              errors.password && touched.password
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.password && touched.password && (
                            <span className="text-red-500 text-sm">
                              {errors.password}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Contact No <span className="text-red-500">*</span>{" "}
                          </label>
                          <input
                            type="text"
                            name="contactno"
                            value={formData.contactno || ""}
                            maxLength={10}
                            placeholder="Enter 10 digit mobile no."
                            onChange={handleInputChange}
                            className={`placeholder:text-sm border p-2 w-full ${
                              errors.contactno && touched.contactno
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.contactno && touched.contactno && (
                            <span className="text-red-500 text-sm">
                              {errors.contactno}
                            </span>
                          )}
                        </div>
                        {isEditMode && (
                          <div>
                            <label className="block text-gray-600">
                              Status
                            </label>
                            <select
                              name="statuss"
                              value={formData.statuss || ""}
                              onChange={handleInputChange}
                              className="border p-2 w-full border-gray-300"
                            >
                              <option>Mark the status</option>
                              <option>Active</option>
                              <option>Inactive</option>
                            </select>
                          </div>
                        )}
                      </div>
                      <div>
                        <label className="block text-gray-600">Address</label>
                        <textarea
                          name="address"
                          value={formData.address || ""}
                          onChange={handleInputChange}
                          className={`border p-2 w-full border-gray-300
                          `}
                          rows="3"
                        ></textarea>
                      </div>
                      <div className="flex justify-end space-x-2 mt-4">
                        <button
                          type="button"
                          onClick={() => {
                            toggleModal();
                            setIsEditMode(false);
                          }}
                          className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                        >
                          Close
                        </button>
                        <button
                          onClick={() => {
                            if (isEditMode) {
                              handleEdit();
                            } else {
                              handleSubmit();
                              setIsEditMode(false);
                            }
                          }}
                          type="button"
                          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                        >
                          {isEditMode ? "Update" : "Submit"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
              <div className="flex items-center space-x-2">
                <input
                  type="text"
                  placeholder="Search"
                  className="border border-gray-300 rounded p-1 w-full sm:w-auto"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col h-screen">
            <div className="overflow-x-auto">
              <table className="w-full text-left   border-collapse text-sm sm:text-xs md:text-sm lg:text-base">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-2">Id</th>
                    <th className="p-2">Photo</th>
                    <th className="p-2">Aadhar No.</th>
                    <th className="p-2">Agent ID</th>
                    <th className="p-2">Name</th>
                    <th className="p-2">Contact No.</th>
                    <th className="p-2">Address</th>
                    <th className="p-2">Status</th>
                    <th className="p-2">Options</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="9" className="text-center p-4">
                        Loading...
                      </td>
                    </tr>
                  ) : currentItems.length > 0 ? (
                    currentItems.map((item) => (
                      <tr key={item.id} className="border-b">
                        <td className="p-2">{item.id}</td>
                        <td className="p-2">
                          <img
                            src={item.imageURL ? item.imageURL : defaultAvatar}
                            alt="User Avatar"
                            className="w-8 h-8 rounded-full"
                          />
                        </td>
                        <td className="p-2">{item.aadhar_no || "--"}</td>
                        <td className="p-2">{item.admin_id || "--"}</td>
                        <td className="p-2">{item.name || "--"}</td>
                        <td className="p-2">{item.contact_no || "--"}</td>
                        <td className="p-2">{item.address || "--"}</td>
                        <td className="p-2">{item.statuss || "--"}</td>
                        <td className="p-2 space-x-3">
                          <button
                            onClick={() => updateData(item.id)}
                            className="text-blue-500"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                          <button
                            onClick={() => handleDelete(item)}
                            className="text-red-500"
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center p-4">
                        No data available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Pagination Controls */}
              <div className="flex justify-between items-center mt-4">
                <p>
                  Showing {indexOfFirstItem + 1} to{" "}
                  {indexOfLastItem > items.length
                    ? items.length
                    : indexOfLastItem}{" "}
                  of {items.length} entries
                </p>
                <div className="flex space-x-2">
                  <button
                    className="border px-2 py-1 rounded"
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </button>
                  {[...Array(totalPages).keys()].map((num) => (
                    <button
                      key={num}
                      className={`border px-2 py-1 rounded ${
                        currentPage === num + 1 ? "bg-blue-500 text-white" : ""
                      }`}
                      onClick={() => handlePageChange(num + 1)}
                    >
                      {num + 1}
                    </button>
                  ))}
                  <button
                    className="border px-2 py-1 rounded"
                    disabled={currentPage === totalPages}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default CollectionAgent;
